// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2XzDq","tab":"Tabs_tab__fSS1a","tabActive":"Tabs_tabActive__3Mxwg"};